/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import axios from 'axios';
import interceptors from './interceptors';

const request = axios.create({
  baseURL: `${process.env.APP_API_URL}/api`,
  timeout: 15000,
});

interceptors(request);

export function setToken(token) {
  request.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function setHeader(item, value) {
  request.defaults.headers.common[item] = value;
}

export const AxiosCancelToken = axios.CancelToken;

export default request;
